import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Badge, FormGroup, ListGroup, ListGroupItem } from "reactstrap";
import { put, get, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate, useParams, Link } from "react-router-dom";
import Loader from "common/loader";
import { SHOW_DRIVER, UPDATE_DRIVER_CONTROL } from "helpers/api_endpoints";
import Select from "react-select";
import { check } from "prettier";
import ChooseModal from "../../components/Common/ChooseModal";


//meta title
document.title = "Driver Control";

const ControlDriver = () => {
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [id, setId] = useState('');
    const [partnerBranches, setPartnerBranches] = useState([]);
    const [regularCoverageAreas, setRegularCoverageAreas] = useState([]);
    const [expressCoverageAreas, setExpressCoverageAreas] = useState([]);
    const [timeSlots, setTimeSlots] = useState([]);
    const [partnerBranchId, setPartnerBranchId] = useState(0);
    const [controls, setControls] = useState([]);
    const [selectedRegularCoverageAreas, setSelectedRegularCoverageAreas] = useState([]);
    const [selectedExpressCoverageAreas, setSelectedExpressCoverageAreas] = useState([]);
    const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [errorMsg, seterrorMsg] = useState('');
    const [chooseModal, setChooseModal] = useState(false);
    const [offDays, setOffDays] = useState({range:[{from:'', to:''}], recurring:[]});
    const navigate = useNavigate();
	const dayOptions = [
		{ value: 0, label: "Sunday" },
		{ value: 1, label: "Monday" },
		{ value: 2, label: "Tuesday" },
		{ value: 3, label: "Wednesday" },
		{ value: 4, label: "Thursday" },
		{ value: 5, label: "Friday" },
		{ value: 6, label: "Saturday" },
	];


    useEffect(() => {
        setDriverData();
    }, []);
    
    useEffect(() => {
        const control = controls.find(el => el.partnerBranchId == partnerBranchId);
        const branch = partnerBranches.find(el => el.value == partnerBranchId);
        console.log('branch', branch)
        if(branch == undefined) return;
        setRegularCoverageAreas(branch.data.regularServiceArea.map((el) => {
            return {value: el.id, label: el.title, data: el}
        }));
        setExpressCoverageAreas(branch.data.expressServiceArea.map((el) => {
            return {value: el.id, label: el.title, data: el}
        }));
        setTimeSlots(branch.data.timeSlot.map((el) => {
            return {value: el.id, label: el.name, data: el}
        }));       
        if(control) 
        {
            setSelectedRegularCoverageAreas(control.driverControlRegularArea?.map((area) => {return {value: area.id, label: ''}}))
            setSelectedExpressCoverageAreas(control.driverControlExpressArea?.map((area) => {return {value: area.id, label: ''}}))
            setSelectedTimeSlots(control.driverControlTimeSlot?.map((slot) => {return {value: slot.id, label: ''}}))
        }
        else
        {
            setSelectedRegularCoverageAreas([]);
            setSelectedExpressCoverageAreas([]);
            setSelectedTimeSlots([]);
        }
    }, [partnerBranchId]);

    const setDriverData = () => {
        get(`${SHOW_DRIVER}/${params.id}`)
            .then(response => {
                const user = response.data.user;
                setId(response.data.id);
                setControls(response.data.control);
                setPartnerBranches(response.data.partnerBranch.map(el => {
                    return {value: el.id, label: el.name, data: el};
                }));
                if(partnerBranches.length == 1)
                    setPartnerBranchId(partnerBranches[0].value);
                setLoading(false);
            })
            .catch(error => {
                console.log(error)
                // navigate('/drivers');
            })
    }

    const handleSubmit = () => {
        updateDriverControlData();
    }
    
    const updateDriverControlData = () => {
        post(UPDATE_DRIVER_CONTROL, {driverId: params.id, partnerBranchId, regularDeliveryAddresses: selectedRegularCoverageAreas
            , expressDeliveryAddresses: selectedExpressCoverageAreas, timeSlots: selectedTimeSlots})
        .then(control => {
            navigate('/drivers', { state: { successMsg: 'Added SuccessFully' } });
        })
    }


    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Drivers" breadcrumbItem="Driver Controls" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        {loading ? <Loader></Loader> :
                                            <Row>
                                                <div className="form-group col-md-12 mt-2">

                                                    <div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Partner Branches</Trans></Label>
                                                            <ListGroup>
                                                            {partnerBranches?partnerBranches.map(branch => (
                                                                <ListGroupItem
                                                                    key={branch.value}
                                                                    onClick={(e) => setPartnerBranchId(branch.value)}
                                                                    action
                                                                    active={partnerBranchId==branch.value}
                                                                >
                                                                    {branch.label}
                                                                </ListGroupItem>
                                                            )):<></>}
                                                            </ListGroup>
                                                        {/* <Select
                                                                name="selectedPartnerBranches"
                                                                value={partnerBranches.filter(branch => partnerBranchId == branch.value
                                                                )}
                                                                options={partnerBranches}
                                                                className="form-control select2"
                                                                onChange={(e) => setPartnerBranchId(e.value)}
                                                                
                                                            /> */}
                                                    </div>

                                                </div>

                                                <div className="form-group col-md-12 mt-2">
                                                    <Row>
                                                        <div className="form-group col-md-4 mt-2">
                                                            <Label className="form-label"><Trans>Regular Coverage Area</Trans></Label>
                                                            <Select
                                                                    name="regularCoverageArea"
                                                                    isMulti
                                                                    value={regularCoverageAreas.filter(area => {
                                                                        return selectedRegularCoverageAreas.find(el => el.value == area.value) != undefined
                                                                    }
                                                                    )}
                                                                    options={regularCoverageAreas}
                                                                    className="form-control select2"
                                                                    onChange={(e) => setSelectedRegularCoverageAreas(e)}
                                                                />
                                                        </div>

                                                        <div className="form-group col-md-4 mt-2">
                                                            <Label className="form-label"><Trans>Express Coverage Area</Trans></Label>
                                                            <Select
                                                                    name="expressCoverageArea"
                                                                    isMulti
                                                                    value={expressCoverageAreas.filter(area => {
                                                                        return selectedExpressCoverageAreas.find(el => el.value == area.value) != undefined
                                                                    }
                                                                    )}
                                                                    options={expressCoverageAreas}
                                                                    className="form-control select2"
                                                                    onChange={(e) => setSelectedExpressCoverageAreas(e)}
                                                                />
                                                        </div>

                                                        <div className="form-group col-md-4 mt-2">
                                                            <Label className="form-label"><Trans>Time Slots</Trans></Label>
                                                            <Select
                                                                    name="selectedTimeSlots"
                                                                    isMulti
                                                                    value={timeSlots.filter(slot => {
                                                                        return selectedTimeSlots.find(el => el.value == slot.value) != undefined
                                                                    }
                                                                    )}
                                                                    options={timeSlots}
                                                                    className="form-control select2"
                                                                    onChange={(e) => setSelectedTimeSlots(e)}
                                                                />
                                                        </div>
                                                    </Row>
                                                </div>
                                                <div className="mt-4">
                                                    <Button type="submit" color="primary">
                                                        <Trans>Submit</Trans>
                                                    </Button>
                                                </div>
                                            </Row>
                                        }
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default ControlDriver
